var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReplication(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 40,
    viewBox: "0 0 97 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property 1=Replication"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line",
    x1: 20.5,
    y1: 19.5,
    x2: 32.5,
    y2: 19.5,
    stroke: "#AED2FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Src"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 12,
    width: 24,
    height: 16,
    rx: 2,
    fill: "#AED2FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fi-rr-copy",
    clipPath: "url(#clip0_23674_349258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M51.5 28H41.5C40.1744 27.9984 38.9036 27.4711 37.9662 26.5338C37.0289 25.5964 36.5016 24.3256 36.5 23V13C36.5016 11.6744 37.0289 10.4036 37.9662 9.46622C38.9036 8.52888 40.1744 8.00159 41.5 8H51.5C52.8256 8.00159 54.0964 8.52888 55.0338 9.46622C55.9711 10.4036 56.4984 11.6744 56.5 13V23C56.4984 24.3256 55.9711 25.5964 55.0338 26.5338C54.0964 27.4711 52.8256 27.9984 51.5 28V28ZM41.5 10C40.7044 10 39.9413 10.3161 39.3787 10.8787C38.8161 11.4413 38.5 12.2044 38.5 13V23C38.5 23.7956 38.8161 24.5587 39.3787 25.1213C39.9413 25.6839 40.7044 26 41.5 26H51.5C52.2956 26 53.0587 25.6839 53.6213 25.1213C54.1839 24.5587 54.5 23.7956 54.5 23V13C54.5 12.2044 54.1839 11.4413 53.6213 10.8787C53.0587 10.3161 52.2956 10 51.5 10H41.5ZM60.5 27V14C60.5 13.7348 60.3946 13.4804 60.2071 13.2929C60.0196 13.1054 59.7652 13 59.5 13C59.2348 13 58.9804 13.1054 58.7929 13.2929C58.6054 13.4804 58.5 13.7348 58.5 14V27C58.5 27.7956 58.1839 28.5587 57.6213 29.1213C57.0587 29.6839 56.2956 30 55.5 30H42.5C42.2348 30 41.9804 30.1054 41.7929 30.2929C41.6054 30.4804 41.5 30.7348 41.5 31C41.5 31.2652 41.6054 31.5196 41.7929 31.7071C41.9804 31.8946 42.2348 32 42.5 32H55.5C56.8256 31.9984 58.0964 31.4711 59.0338 30.5338C59.9711 29.5964 60.4984 28.3256 60.5 27V27Z",
    fill: "#265EDB"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Dest"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.5,
    y: 12,
    width: 24,
    height: 16,
    rx: 2,
    fill: "#AED2FF"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    x1: 64.5,
    y1: 19.5,
    x2: 76.5,
    y2: 19.5,
    stroke: "#AED2FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23674_349258"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(36.5 8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplication);
export default __webpack_public_path__ + "static/media/replication.2740630afd181c8b8e29c364c900edfe.svg";
export { ForwardRef as ReactComponent };